import React, { Fragment, useState, useContext, useEffect } from 'react';
import { LI } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';

const MoonLight = () => {
    const { addMixBackgroundLayout, loadMixBackgroundLayout } = useContext(CustomizerContext);
    const [moonlight, setMoonlight] = useState(false);

    const MoonlightToggle = (light) => {
        if (light) {
            addMixBackgroundLayout('light-only');
            document.body.className = 'light-only';
            setMoonlight(!light);
        } else {
            addMixBackgroundLayout('dark-only');
            document.body.className = 'dark-only';
            setMoonlight(!light);
        }
    };

    useEffect(() => {
        loadMixBackgroundLayout(setMoonlight, moonlight)
    }, [])

    return (
        <Fragment>
            <LI attrLI={{ onClick: () => MoonlightToggle(moonlight), style: { cursor: 'pointer' } }}>
                <div className="mode">
                    {moonlight ? <i className="fa fa-lightbulb-o" style={{ fontSize: '18px', width: '18px', textAlign: 'center' }}></i> : <i className="fa fa-moon-o" style={{ fontSize: '18px', width: '18px', textAlign: 'center' }}></i>}
                </div>
            </LI>
        </Fragment>
    );
};

export default MoonLight;